var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component_name,{tag:"component",attrs:{"id":_vm.id,"item_id":_vm.item_id,"other_item_id":_vm.other_item_id,"item_type":_vm.item_type,"action":_vm.action,"other_info_string":_vm.other_info_string}})}
var staticRenderFns = []

export { render, staticRenderFns }